// Components
import Divider from 'ui/Divider/Divider';
import styles from './TermsOfServiceContent.module.scss';
import termsOfServiceMarkup from './termsOfServiceMarkup';

const TermsOfServiceContent = () => {
  return (
    <main className={styles.root}>
      <div className={styles.container}>
        <div>
          <h1 className={styles.title}>MILLIONS.CO – TERMS AND CONDITIONS</h1>
          <p style={{ textAlign: 'center', marginBottom: '16px' }}>
            Last Updated: September 16, 2026
          </p>
          <p style={{ marginBottom: '24px', fontWeight: 'bold' }}>
            IMPORTANT – PLEASE READ CAREFULLY.
          </p>
          <p style={{ marginBottom: '24px' }}>
            These Terms and Conditions (these <strong>&quot;Terms&quot;</strong>
            ) form a legally binding agreement between you and Millions.co Inc.
            (<strong>&quot;MILLIONS&quot;</strong>,{' '}
            <strong>&quot;we&quot;</strong>, <strong>&quot;us&quot;</strong>, or{' '}
            <strong>&quot;our&quot;</strong>) governing your access to and use
            of:
          </p>
          <ul
            style={{
              marginLeft: '20px',
              marginBottom: '24px',
              listStyle: 'disc',
            }}
          >
            <li>
              the website located at www.millions.co and any related domains or
              subdomains;
            </li>
            <li>the MILLIONS mobile applications;</li>
            <li>
              the MILLIONS Campaign Manager and advertising platform located at
              campaign.millions.co and related URLs; and
            </li>
            <li>
              MILLIONS applications and viewing services made available on
              supported Smart TVs and connected-TV devices,
            </li>
          </ul>
          <p style={{ marginBottom: '24px' }}>
            (collectively, the <strong>&quot;Platform&quot;</strong>).
          </p>
          <p style={{ marginBottom: '32px' }}>
            By accessing or using the Platform in any manner, including but not
            limited to visiting or browsing the Platform, creating an account,
            creating or interacting with Talent profiles, purchasing products,
            viewing content, sending tips, or creating or managing Campaigns or
            Offers, you agree to be bound by these Terms. If you do not agree to
            these Terms, you must not use the Platform.
          </p>
          <Divider className={styles.divider} />
        </div>
        <div
          className={styles.document}
          dangerouslySetInnerHTML={{ __html: termsOfServiceMarkup }}
        />
      </div>
    </main>
  );
};

export default TermsOfServiceContent;
